import ImageWithFallback from '@/components/ui/ImageWithFallback'
import { storeService } from '@/domain/Store'
import { WithAverageRating } from '@/domain/Store/repositories/store'
import { getCachedStore, getCachedStoreSync, getStore } from '@/utils/store'
import { Store } from '@medusajs/medusa'
import Image from 'next/image'
import React, { useEffect, useState } from 'react'

type Props = {
    className?: string
    style?: React.CSSProperties
} & React.SVGProps<SVGSVGElement>

const StouxLogo = ({ className, style, ...props }: Props) => {
    const store = getStore()
    const [storedto, setStoredto] = useState<
        (Store & WithAverageRating) | null
    >(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (!store) {
            setLoading(false)
            return
        }

       const cached = getCachedStoreSync();
        if (cached  ) {
            setStoredto(cached)
            setLoading(false)
            return
        }
        
        getCachedStore().then((res) => {
            setStoredto(res)
            setLoading(false)
        })

    }, [store])

    if (loading) return <div style={{ width: 203, height: 74 }} />


    if (!store || storedto?.metadata?.thumbnail == null) {
        return (
            <svg
                className={className}
                style={style}
                width="203"
                height="74"
                viewBox="0 0 203 74"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    d="M31.6 67.4H5.60001V56.1H31.6C32.4 56.1 33 55.8 33.6 55.3C34.2 54.7 34.4 54.1 34.4 53.3C34.4 52.5 34.1 52 33.6 51.7C33 51.4 32.4 51.3 31.6 51.3H19.8C17.8 51.3 16 50.9 14.3 50.2C12.6 49.4 11.1 48.4 9.80001 47.1C8.50001 45.8 7.50001 44.3 6.80001 42.6C6.00001 40.9 5.60001 39 5.60001 37C5.60001 35 6.00001 33.2 6.70001 31.5C7.40001 29.8 8.40001 28.3 9.70001 27C11 25.7 12.5 24.7 14.2 24C15.9 23.3 17.8 22.9 19.7 22.9H42.8V34.2H19.8C19 34.2 18.4 34.5 17.8 35C17.2 35.6 17 36.2 17 37C17 37.8 17.3 38.5 17.8 39.1C18.4 39.7 19 40 19.8 40H31.6C33.5 40 35.4 40.3 37.1 41C38.8 41.7 40.3 42.6 41.6 43.7C42.9 44.9 43.9 46.3 44.6 47.9C45.4 49.5 45.7 51.3 45.7 53.3C45.7 55.3 45.3 57.1 44.6 58.8C43.8 60.5 42.8 62 41.6 63.3C40.3 64.6 38.8 65.6 37.1 66.3C35.4 67.1 33.6 67.4 31.6 67.4Z"
                    fill="currentColor"
                />
                <path
                    d="M67.4 67.4C64.6 67.4 62.1 66.9 59.6 65.8C57.2 64.8 55.1 63.3 53.2 61.5C51.4 59.7 49.9 57.6 48.9 55.1C47.9 52.7 47.3 50.1 47.3 47.3V34.2H41.8V22.9H47.3V5H58.6V22.8H76V34.1H58.8V47.4C58.8 48.6 59 49.7 59.5 50.8C59.9 51.8 60.6 52.8 61.3 53.5C62.1 54.3 63 54.9 64.1 55.4C65.2 55.9 66.3 56.1 67.5 56.1H76V67.4H67.4Z"
                    fill="currentColor"
                />
                <path
                    d="M136.8 22.6V48.3C136.8 50.7 136.2 52.5 135.1 53.8C133.9 55.1 132.2 55.8 130 55.8C127.7 55.8 126 55.1 124.9 53.8C123.8 52.5 123.2 50.7 123.2 48.3V22.6H110.9V29.4C115 33.4 117.6 38.9 117.6 45C117.6 50 115.9 54.6 113.1 58.2C113.2 58.4 113.3 58.6 113.4 58.8C115 61.7 117.2 63.8 120.1 65.2C122.9 66.6 126.2 67.4 129.8 67.4C133.4 67.4 136.7 66.7 139.6 65.2C142.6 63.8 144.9 61.6 146.6 58.7C148.3 55.8 149.2 52.4 149.2 48.3V22.6H136.8Z"
                    fill="currentColor"
                />
                <path
                    d="M179.6 67.4L171 54.8L163.6 67.4H149.5L164 44.6L149 22.9H163.6L172 35.1L179.2 22.9H193.3L179 45.3L194.2 67.4H179.6Z"
                    fill="currentColor"
                />
                <g>
                    <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 95 44"
                        to="360 95 44"
                        dur="4s"
                        repeatCount="indefinite"
                    />

                    <path
                        d="M94.9 60.9C86.4 60.5 79.6 53.5 79.6 44.8C79.6 42.5 80.1 40.4 80.9 38.4L91.3 44.4C94.8 46.4 95.4 45.9 95 50.4C94.8 52.3 94.1 53.1 90.9 50.4L92.8 49.8L86 44L84.3 52.7L87.2 51.7C92.6 58.5 94.9 51.3 94.9 60.9Z"
                        fill="currentColor"
                    />

                    <mask
                        id="mask0_26_183"
                        maskUnits="userSpaceOnUse"
                        x="79"
                        y="38"
                        width="17"
                        height="23"
                    >
                        <path
                            d="M94.9 60.9C86.4 60.5 79.6 53.5 79.6 44.8C79.6 42.5 80.1 40.4 80.9 38.4L91.3 44.4C94.8 46.4 95.4 45.9 95 50.4C94.8 52.3 94.1 53.1 90.9 50.4L92.8 49.8L86 44L84.3 52.7L87.2 51.7C92.6 58.5 94.9 51.3 94.9 60.9Z"
                            fill="white"
                        />
                    </mask>
                    <g mask="url(#mask0_26_183)">
                        <path
                            d="M95.3 38.5H79.6V60.9H95.3V38.5Z"
                            fill="currentColor"
                        />
                    </g>

                    <path
                        d="M110.4 38.6C111.2 40.5 111.7 42.7 111.7 44.9C111.7 53.5 105 60.5 96.5 61V50.8C96.5 46.1 95.8 47 99.8 44.4C102.3 42.8 104.1 42.2 102.6 47.5L101.1 46.2L99.4 55L107.8 52.1L105.5 50.1C106.5 47.4 106.8 45.4 106.1 42.7C105.9 41.6 106.2 41 110.4 38.6Z"
                        fill="currentColor"
                    />

                    <mask
                        id="mask1_26_183"
                        maskUnits="userSpaceOnUse"
                        x="96"
                        y="38"
                        width="16"
                        height="23"
                    >
                        <path
                            d="M110.4 38.6C111.2 40.5 111.7 42.7 111.7 44.9C111.7 53.5 105 60.5 96.5 61V50.8C96.5 46.1 95.8 47 99.8 44.4C102.3 42.8 104.1 42.2 102.6 47.5L101.1 46.2L99.4 55L107.8 52.1L105.5 50.1C106.5 47.4 106.8 45.4 106.1 42.7C105.9 41.6 106.2 41 110.4 38.6Z"
                            fill="white"
                        />
                    </mask>
                    <g mask="url(#mask1_26_183)">
                        <path
                            d="M111.7 38.6H95.8V61H111.7V38.6Z"
                            fill="currentColor"
                        />
                    </g>

                    <path
                        d="M95.7 28.8C101.8 28.8 107 32.1 109.8 37.1L99.4 43.1C95.6 45.3 96 45.8 92 43.2C89.7 41.7 88.2 39.7 93.2 37.9L92.8 39.8L101.2 36.9L94.5 31L93.9 34C84.6 35.5 88.7 41.2 81.6 37C84.4 32.1 89.6 28.8 95.7 28.8Z"
                        fill="currentColor"
                    />

                    <mask
                        id="mask2_26_183"
                        maskUnits="userSpaceOnUse"
                        x="81"
                        y="28"
                        width="29"
                        height="17"
                    >
                        <path
                            d="M95.7 28.8C101.8 28.8 107 32.1 109.8 37.1L99.4 43.1C95.6 45.3 96 45.8 92 43.2C89.7 41.7 88.2 39.7 93.2 37.9L92.8 39.8L101.2 36.9L94.5 31L93.9 34C84.6 35.5 88.7 41.2 81.6 37C84.4 32.1 89.6 28.8 95.7 28.8Z"
                            fill="white"
                        />
                    </mask>
                    <g mask="url(#mask2_26_183)">
                        <path
                            d="M109.7 28.8H81.6V45.8H109.7V28.8Z"
                            fill="currentColor"
                        />
                    </g>
                </g>
            </svg>
        )
    }

    return (
        <div style={{ position: 'relative', width: 203, height: 74, ...style }}>
            <ImageWithFallback
                src={storedto.metadata.thumbnail as string}
                alt="Stoux Logo"
                fill
                style={{ objectFit: 'contain' }}
            />
        </div>
    )
}

export default StouxLogo
